import { Component, OnInit } from '@angular/core';

import { HunspellSpellCheckService } from '../../../services/documents/hunspell-spell-check.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-hunspell-spell-check-index',
  templateUrl: './hunspell-spell-check-index.component.html',
  styleUrls: ['./hunspell-spell-check-index.component.scss'],
})
export class HunspellSpellCheckIndexComponent implements OnInit {
  addingWord: boolean = false;

  loading: boolean = true;

  newWord: string;

  removingWord: boolean = false;

  words: Array<string> = [];

  constructor(private hunspellSpellCheckService: HunspellSpellCheckService, private notyService: NotyService) {}

  ngOnInit() {
    this.loadWords();
  }

  addWord() {
    if (this.newWord) {
      this.addingWord = true;
      this.hunspellSpellCheckService
        .addWord(this.newWord)
        .then((response_json) => {
          this.addingWord = false;
          if (response_json.success) {
            this.notyService.notify(response_json.text || 'Word added', 'success');
            this.newWord = '';
            this.loadWords();
          } else this.notyService.notify(response_json.text || 'Please enter a new word', 'error');
        })
        .catch(() => {
          this.addingWord = false;
          this.notyService.notify('Error adding new word', 'error');
        });
    } else this.notyService.notify('Please enter a new word', 'error');
  }

  loadWords() {
    this.loading = true;
    this.hunspellSpellCheckService.index().then((response_json) => {
      this.loading = false;
      this.words = response_json;
    });
  }

  removeWord(word: string) {
    this.removingWord = true;
    this.hunspellSpellCheckService
      .delete(word)
      .then((response_json) => {
        this.removingWord = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Word deleted', 'success');
          this.loadWords();
        } else this.notyService.notify(response_json.text || 'Error deleting word', 'error');
      })
      .catch(() => {
        this.removingWord = false;
        this.notyService.notify('Error deleting word', 'error');
      });
  }
}
